import React from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "@material-ui/styles";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import theme from "../../../../Themes/defaultTheme";

const useStyles = makeStyles(() => ({
  paper: ({ width }) => ({
    width,
    maxWidth: "92vw",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.22)",
    overflowX: "hidden",
  }),
}));

const A_Drawer = (props) => {
  const { anchor, open, onClose, content, width, className, PaperProps, disableBackdropClick } =
    props;
  const classes = useStyles({ width });

  const handleClose = (event, reason) => {
    if (disableBackdropClick && reason === "backdropClick") return;
    if (onClose) onClose(event, reason);
  };

  return (
    <ThemeProvider theme={theme}>
      <Drawer
        anchor={anchor}
        open={open}
        onClose={handleClose}
        className={className}
        PaperProps={{
          ...PaperProps,
          className: `${classes.paper} ${
            (PaperProps && PaperProps.className) || ""
          }`,
        }}
      >
        {content}
      </Drawer>
    </ThemeProvider>
  );
};

A_Drawer.defaultProps = {
  open: false,
  anchor: "left",
  width: 300,
};

A_Drawer.propTypes = {
  open: PropTypes.bool,
  anchor: PropTypes.oneOf(["left", "right", "top", "bottom"]),
  onClose: PropTypes.func,
  content: PropTypes.node,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  PaperProps: PropTypes.object,
  disableBackdropClick: PropTypes.bool,
};

export default A_Drawer;
